export const THUMB_XS = 'w=80';
export const THUMB_SM = 'w=300';
export const THUMB_MD = 'w=800';
export const THUMB_LG = 'w=1200';

export const THUMB_SQUARE_XS = 'fit=crop&h=80&w=80';
export const THUMB_SQUARE_SM = 'fit=crop&h=300&w=300';
export const THUMB_SQUARE_MD = 'fit=crop&h=800&w=800';
export const THUMB_SQUARE_LG = 'fit=crop&h=1200&w=1200';

export const RESET_USER_STATE = 'RESET_USER_STATE';
export const FETCH_USER_SELF_REQUEST = 'FETCH_USER_SELF_REQUEST';
export const FETCH_USER_SELF_IDLE = 'FETCH_USER_SELF_IDLE';
export const FETCH_USER_SELF_SUCCSSS = 'FETCH_USER_SELF_SUCCSSS';
export const FETCH_USER_SELF_FAILURE = 'FETCH_USER_SELF_FAILURE';
export const SET_USER_LANGUAGE = 'SET_USER_LANGUAGE';

export const LIST_COTTAGE_IMAGES_REQUEST = 'LIST_COTTAGE_IMAGES_REQUEST';
export const LIST_COTTAGE_IMAGES_IDLE = 'LIST_COTTAGE_IMAGES_IDLE';
export const LIST_COTTAGE_IMAGES_SUCCESS = 'LIST_COTTAGE_IMAGES_SUCCESS';
export const LIST_COTTAGE_IMAGES_FAILURE = 'LIST_COTTAGE_IMAGES_FAILURE';

export const REORDER_COTTAGE_IMAGES = 'REORDER_COTTAGE_IMAGES';
export const REORDER_COTTAGE_IMAGES_REQUEST = 'REORDER_COTTAGE_IMAGES_REQUEST';
export const REORDER_COTTAGE_IMAGES_IDLE = 'REORDER_COTTAGE_IMAGES_IDLE';
export const REORDER_COTTAGE_IMAGES_SUCCESS = 'REORDER_COTTAGE_IMAGES_SUCCESS';
export const REORDER_COTTAGE_IMAGES_FAILURE = 'REORDER_COTTAGE_IMAGES_FAILURE';

export const REMOVE_COTTAGE_IMAGES_REQUEST = 'REMOVE_COTTAGE_IMAGES_REQUEST';
export const REMOVE_COTTAGE_IMAGES_IDLE = 'REMOVE_COTTAGE_IMAGES_IDLE';
export const REMOVE_COTTAGE_IMAGES_SUCCESS = 'REMOVE_COTTAGE_IMAGES_SUCCESS';
export const REMOVE_COTTAGE_IMAGES_FAILURE = 'REMOVE_COTTAGE_IMAGES_FAILURE';

export const UPDATE_COTTAGE_IMAGE_REQUEST = 'UPDATE_COTTAGE_IMAGE_REQUEST';
export const UPDATE_COTTAGE_IMAGE_IDLE = 'UPDATE_COTTAGE_IMAGE_IDLE';
export const UPDATE_COTTAGE_IMAGE_SUCCESS = 'UPDATE_COTTAGE_IMAGE_SUCCESS';
export const UPDATE_COTTAGE_IMAGE_FAILURE = 'UPDATE_COTTAGE_IMAGE_FAILURE';

export const OPEN_IMAGE_DELETE_CONFIRMATION_MODAL = 'OPEN_IMAGE_DELETE_CONFIRMATION_MODAL';
export const CLOSE_IMAGE_DELETE_CONFIRMATION_MODAL = 'CLOSE_IMAGE_DELETE_CONFIRMATION_MODAL';

export const OPEN_IMAGE_UPLOAD_LEAVE_PAGE_MODAL = 'OPEN_IMAGE_UPLOAD_LEAVE_PAGE_MODAL';
export const CLOSE_IMAGE_UPLOAD_LEAVE_PAGE_MODAL = 'CLOSE_IMAGE_UPLOAD_LEAVE_PAGE_MODAL';

export const OPEN_USER_SETTINGS_CONFIRMATION_MODAL = 'OPEN_USER_SETTINGS_CONFIRMATION_MODAL';
export const CLOSE_USER_SETTINGS_CONFIRMATION_MODAL = 'CLOSE_USER_SETTINGS_CONFIRMATION_MODAL';

export const FETCH_ROOM_REQUEST = 'FETCH_ROOM_REQUEST';
export const FETCH_ROOM_IDLE = 'FETCH_ROOM_IDLE';
export const FETCH_ROOM_SUCCESS = 'FETCH_ROOM_SUCCESS';
export const FETCH_ROOM_FAILURE = 'FETCH_ROOM_FAILURE';

export const FETCH_COTTAGE_IMAGE_REQUEST = 'FETCH_COTTAGE_IMAGE_REQUEST';
export const FETCH_COTTAGE_IMAGE_IDLE = 'FETCH_COTTAGE_IMAGE_IDLE';
export const FETCH_COTTAGE_IMAGE_SUCCESS = 'FETCH_COTTAGE_IMAGE_SUCCESS';
export const FETCH_COTTAGE_IMAGE_FAILURE = 'FETCH_COTTAGE_IMAGE_FAILURE';
export const FETCH_COTTAGE_IMAGE_DESTROY = 'FETCH_COTTAGE_IMAGE_DESTROY';

export const SWITCH_CURRENT_IFRAME_ROUTE = 'SWITCH_CURRENT_IFRAME_ROUTE';

export const POST_LOGIN_REQUEST = 'POST_LOGIN_REQUEST';
export const POST_LOGIN_IDLE = 'POST_LOGIN_IDLE';
export const POST_LOGIN_SUCCESS = 'POST_LOGIN_SUCCESS';
export const POST_LOGIN_FAILURE = 'POST_LOGIN_FAILURE';

export const POST_CREATE_USER_SUCCESS = 'POST_CREATE_USER_SUCCESS';

export const POST_LOGOUT_REQUEST = 'POST_LOGOUT_REQUEST';
export const POST_LOGOUT_IDLE = 'POST_LOGOUT_IDLE';
export const POST_LOGOUT_SUCCESS = 'POST_LOGOUT_SUCCESS';
export const POST_LOGOUT_FAILURE = 'POST_LOGOUT_FAILURE';

export const UPDATE_USER_SETTINGS_REQUEST = 'UPDATE_USER_SETTINGS_REQUEST';
export const UPDATE_USER_SETTINGS_IDLE = 'UPDATE_USER_SETTINGS_IDLE';
export const UPDATE_USER_SETTINGS_SUCCESS = 'UPDATE_USER_SETTINGS_SUCCESS';
export const UPDATE_USER_SETTINGS_FAILURE = 'UPDATE_USER_SETTINGS_FAILURE';

export const COTTAGE_IMAGE_UPLOAD_REQUEST = 'COTTAGE_IMAGE_UPLOAD_REQUEST';
export const COTTAGE_IMAGE_UPLOAD_INSERT = 'COTTAGE_IMAGE_UPLOAD_INSERT';
export const COTTAGE_IMAGE_UPLOAD_UPDATE = 'COTTAGE_IMAGE_UPLOAD_UPDATE';
export const COTTAGE_IMAGE_UPLOAD_IDLE = 'COTTAGE_IMAGE_UPLOAD_IDLE';
export const COTTAGE_IMAGE_UPLOAD_SUCCESS = 'COTTAGE_IMAGE_UPLOAD_SUCCESS';
export const COTTAGE_IMAGE_UPLOAD_FAILURE = 'COTTAGE_IMAGE_UPLOAD_FAILURE';

export const GENERATE_IMAGE_PREVIEW_REQUEST = 'GENERATE_IMAGE_PREVIEW_REQUEST';
export const GENERATE_IMAGE_PREVIEW_IDLE = 'GENERATE_IMAGE_PREVIEW_IDLE';
export const GENERATE_IMAGE_PREVIEW_SUCCESS = 'GENERATE_IMAGE_PREVIEW_SUCCESS';
export const GENERATE_IMAGE_PREVIEW_FAILURE = 'GENERATE_IMAGE_PREVIEW_FAILURE';

export const FETCH_ROOM_FACILITIES_REQUEST = 'FETCH_ROOM_FACILITIES_REQUEST';
export const FETCH_ROOM_FACILITIES_IDLE = 'FETCH_ROOM_FACILITIES_IDLE';
export const FETCH_ROOM_FACILITIES_SUCCSSS = 'FETCH_ROOM_FACILITIES_SUCCSSS';
export const FETCH_ROOM_FACILITIES_FAILURE = 'FETCH_ROOM_FACILITIES_FAILURE';

export const UPDATE_ROOM_FACILITIES_REQUEST = 'UPDATE_ROOM_FACILITIES_REQUEST';
export const UPDATE_ROOM_FACILITIES_IDLE = 'UPDATE_ROOM_FACILITIES_IDLE';
export const UPDATE_ROOM_FACILITIES_SUCCSSS = 'UPDATE_ROOM_FACILITIES_SUCCSSS';
export const UPDATE_ROOM_FACILITIES_FAILURE = 'UPDATE_ROOM_FACILITIES_FAILURE';

export const FETCH_ROOM_TEXTS_REQUEST = 'FETCH_ROOM_TEXTS_REQUEST';
export const FETCH_ROOM_TEXTS_IDLE = 'FETCH_ROOM_TEXTS_IDLE';
export const FETCH_ROOM_TEXTS_SUCCSSS = 'FETCH_ROOM_TEXTS_SUCCSSS';
export const FETCH_ROOM_TEXTS_FAILURE = 'FETCH_ROOM_TEXTS_FAILURE';

export const UPDATE_ROOM_TEXTS_REQUEST = 'UPDATE_ROOM_TEXTS_REQUEST';
export const UPDATE_ROOM_TEXTS_IDLE = 'UPDATE_ROOM_TEXTS_IDLE';
export const UPDATE_ROOM_TEXTS_SUCCSSS = 'UPDATE_ROOM_TEXTS_SUCCSSS';
export const UPDATE_ROOM_TEXTS_FAILURE = 'UPDATE_ROOM_TEXTS_FAILURE';

export const FETCH_ROOM_NEARBYS_REQUEST = 'FETCH_ROOM_NEARBYS_REQUEST';
export const FETCH_ROOM_NEARBYS_IDLE = 'FETCH_ROOM_NEARBYS_IDLE';
export const FETCH_ROOM_NEARBYS_SUCCSSS = 'FETCH_ROOM_NEARBYS_SUCCSSS';
export const FETCH_ROOM_NEARBYS_FAILURE = 'FETCH_ROOM_NEARBYS_FAILURE';

export const UPDATE_ROOM_NEARBYS_REQUEST = 'UPDATE_ROOM_NEARBYS_REQUEST';
export const UPDATE_ROOM_NEARBYS_IDLE = 'UPDATE_ROOM_NEARBYS_IDLE';
export const UPDATE_ROOM_NEARBYS_SUCCSSS = 'UPDATE_ROOM_NEARBYS_SUCCSSS';
export const UPDATE_ROOM_NEARBYS_FAILURE = 'UPDATE_ROOM_NEARBYS_FAILURE';

export const FETCH_CALENDAR_REQUEST = 'FETCH_CALENDAR_REQUEST';
export const FETCH_CALENDAR_IDLE = 'FETCH_CALENDAR_IDLE';
export const FETCH_CALENDAR_SUCCESS = 'FETCH_CALENDAR_SUCCESS';
export const FETCH_CALENDAR_FAILURE = 'FETCH_CALENDAR_FAILURE';

export const UPDATE_CALENDAR_REQUEST = 'UPDATE_CALENDAR_REQUEST';
export const UPDATE_CALENDAR_IDLE = 'UPDATE_CALENDAR_IDLE';
export const UPDATE_CALENDAR_SUCCESS = 'UPDATE_CALENDAR_SUCCESS';
export const UPDATE_CALENDAR_FAILURE = 'UPDATE_CALENDAR_FAILURE';
export const SET_CALENDAR_ROWS = 'SET_CALENDAR_ROWS';

export const UPDATE_COTTAGE_SETTINGS_REQUEST = 'UPDATE_COTTAGE_SETTINGS_REQUEST';
export const UPDATE_COTTAGE_SETTINGS_IDLE = 'UPDATE_COTTAGE_SETTINGS_IDLE';
export const UPDATE_COTTAGE_SETTINGS_SUCCESS = 'UPDATE_COTTAGE_SETTINGS_SUCCESS';
export const UPDATE_COTTAGE_SETTINGS_FAILURE = 'UPDATE_COTTAGE_SETTINGS_FAILURE';

export const LOGIN_CHECK_USERNAME_REQUEST = 'LOGIN_CHECK_USERNAME_REQUEST';
export const LOGIN_SET_USERTYPE = 'LOGIN_SET_USERTYPE';
export const LOGIN_RESET_FORM = 'LOGIN_RESET_FORM';
export const LOGIN_CREATE_USER_REQUEST = 'LOGIN_CREATE_USER_REQUEST';

export const LOGIN_RESET_PASSWORD_REQUEST = 'LOGIN_RESET_PASSWORD_REQUEST';
export const LOGIN_RESET_PASSWORD_SUCCESS = 'LOGIN_RESET_PASSWORD_SUCCESS';
export const LOGIN_RESET_PASSWORD_FAILURE = 'LOGIN_RESET_PASSWORD_FAILURE';
export const LOGIN_RESET_PASSWORD_IDLE = 'LOGIN_RESET_PASSWORD_IDLE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const UPDATE_USER_IDLE = 'UPDATE_USER_IDLE';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';
export const DELETE_USER_IDLE = 'DELETE_USER_IDLE';

export const RESET_USER_FORM = 'RESET_USER_FORM';

export const FETCH_BOOKINGS_INFO_REQUEST = 'FETCH_BOOKINGS_INFO_REQUEST';
export const FETCH_BOOKINGS_INFO_SUCCESS = 'FETCH_BOOKINGS_INFO_SUCCESS';
export const FETCH_BOOKINGS_INFO_FAILURE = 'FETCH_BOOKINGS_INFO_FAILURE';

export const FETCH_BOOKINGS_REQUEST = 'FETCH_BOOKINGS_REQUEST';
export const FETCH_BOOKINGS_SUCCESS = 'FETCH_BOOKINGS_SUCCESS';
export const FETCH_BOOKINGS_FAILURE = 'FETCH_BOOKINGS_FAILURE';

export const FETCH_BOOKING_REQUEST = 'FETCH_BOOKING_REQUEST';
export const FETCH_BOOKING_SUCCESS = 'FETCH_BOOKING_SUCCESS';
export const FETCH_BOOKING_FAILURE = 'FETCH_BOOKING_FAILURE';

export const FETCH_CANCELLATION_POLICY_REQUEST = 'FETCH_CANCELLATION_POLICY_REQUEST';
export const FETCH_CANCELLATION_POLICY_SUCCESS = 'FETCH_CANCELLATION_POLICY_SUCCESS';
export const FETCH_CANCELLATION_POLICY_FAILURE = 'FETCH_CANCELLATION_POLICY_FAILURE';

export const POST_BOOKING_REQUEST = 'POST_BOOKING_REQUEST';
export const POST_BOOKING_SUCCESS = 'POST_BOOKING_SUCCESS';
export const POST_BOOKING_FAILURE = 'POST_BOOKING_FAILURE';
export const POST_BOOKING_IDLE = 'POST_BOOKING_IDLE';

export const PUT_BOOKING_REQUEST = 'PUT_BOOKING_REQUEST';
export const PUT_BOOKING_SUCCESS = 'PUT_BOOKING_SUCCESS';
export const PUT_BOOKING_FAILURE = 'PUT_BOOKING_FAILURE';
export const PUT_BOOKING_IDLE = 'PUT_BOOKING_IDLE';

export const BOOKING_ACTION_REQUEST = 'BOOKING_ACTION_REQUEST';
export const BOOKING_ACTION_SUCCESS = 'BOOKING_ACTION_SUCCESS';
export const BOOKING_ACTION_FAILURE = 'BOOKING_ACTION_FAILURE';

export const BOOKING_OFFER_STALE_SET = 'BOOKING_OFFER_STALE_SET';
export const BOOKING_OFFER_STALE_CLEAR = 'BOOKING_OFFER_STALE_CLEAR';

export const FETCH_UPLOADED_KYC_REQUEST = 'FETCH_UPLOADED_KYC_REQUEST';
export const FETCH_UPLOADED_KYC_SUCCESS = 'FETCH_UPLOADED_KYC_SUCCESS';
export const FETCH_UPLOADED_KYC_FAILURE = 'FETCH_UPLOADED_KYC_FAILURE';

export const UPLOAD_IDPROOF_REQUEST = 'UPLOAD_IDPROOF_REQUEST';
export const UPLOAD_IDPROOF_SUCCESS = 'UPLOAD_IDPROOF_SUCCESS';
export const UPLOAD_IDPROOF_FAILURE = 'UPLOAD_IDPROOF_FAILURE';
export const UPLOAD_IDPROOF_IDLE = 'UPLOAD_IDPROOF_IDLE';

export const POST_AUTH_TOKEN_REQUEST = 'POST_AUTH_TOKEN_REQUEST';
export const POST_AUTH_TOKEN_RESPONSE = 'POST_AUTH_TOKEN_RESPONSE';

export const AUTH_TOKEN_SENT = 'AUTH_TOKEN_SENT';
export const AUTH_TOKEN_FAILURE = 'AUTH_TOKEN_FAILURE';

export const FETCH_SELF_EVENTS_REQUEST = 'FETCH_SELF_EVENTS_REQUEST';
export const FETCH_SELF_EVENTS_SUCCESS = 'FETCH_SELF_EVENTS_SUCCESS';
export const FETCH_SELF_EVENTS_FAILURE = 'FETCH_SELF_EVENTS_FAILURE';
export const UPDATE_SELF_EVENTS_REQUEST = 'UPDATE_SELF_EVENTS_REQUEST';
export const UPDATE_SELF_EVENTS_FAILURE = 'UPDATE_SELF_EVENTS_FAILURE';

export const SNACKBAR_SHOW = 'SNACKBAR_SHOW';
export const SNACKBAR_HIDE = 'SNACKBAR_HIDE';

export const FETCH_TODOS_REQUEST = 'FETCH_TODOS_REQUEST';
export const FETCH_TODOS_SUCCESS = 'FETCH_TODOS_SUCCESS';
export const FETCH_TODOS_FAILURE = 'FETCH_TODOS_FAILURE';
export const PATCH_TODOS_READ_NEWS = 'PATCH_TODOS_READ_NEWS';

export const SCA_PRE_ENROLL = 'SCA_PRE_ENROLL';
export const SCA_PRE_ENROLL_RESET = 'SCA_PRE_ENROLL_RESET';
export const SCA_RECIPIENT_ENROLL = 'SCA_RECIPIENT_ENROLL';
export const SCA_RECIPIENT_ENROLL_RESET = 'SCA_RECIPIENT_ENROLL_RESET';
export const SCA_START_ENROLLMENT = 'SCA_START_ENROLLMENT';
export const SCA_START_RECIPIENT_ENROLLMENT = 'SCA_START_RECIPIENT_ENROLLMENT';
export const SCA_TRIGGER_ON = 'SCA_TRIGGER_ON';
export const SCA_TRIGGER_OFF = 'SCA_TRIGGER_OFF';
export const SCA_VERIFY_REDIRECT_PARAMS = 'SCA_VERIFY_REDIRECT_PARAMS';
export const SCA_VERIFY_REDIRECT_SUCCESS = 'SCA_VERIFY_REDIRECT_SUCCESS';
export const SCA_VERIFY_REDIRECT_FAILURE = 'SCA_VERIFY_REDIRECT_FAILURE';
export const SCA_VERIFICATION_RESET = 'SCA_VERIFICATION_RESET';
export const SCA_SYNC_RECIPIENT = 'SCA_SYNC_RECIPIENT';
export const SCA_SYNC_RECIPIENT_SUCCESS = 'SCA_SYNC_RECIPIENT_SUCCESS';
export const SCA_SYNC_RECIPIENT_FAILURE = 'SCA_SYNC_RECIPIENT_FAILURE';
export const SCA_SYNC_RECIPIENT_RESET = 'SCA_SYNC_RECIPIENT_RESET';
export const SCA_RECIPIENT_READY = 'SCA_RECIPIENT_READY';
export const SCA_VERIFY_RECIPIENT_REDIRECT_PARAMS = 'SCA_VERIFY_RECIPIENT_REDIRECT_PARAMS';

export const SCA_RESUME_REQUEST = 'SCA_RESUME_REQUEST';
export const SCA_RESUME_SUCCESS = 'SCA_RESUME_SUCCESS';
export const SCA_RESUME_FAILURE = 'SCA_RESUME_FAILURE';
export const SCA_RESUME_TICK_COOLDOWN = 'SCA_RESUME_TICK_COOLDOWN';

export const SCA_POLL_LOCAL_REQUEST = 'SCA_POLL_LOCAL_REQUEST';
export const SCA_POLL_LOCAL_DONE = 'SCA_POLL_LOCAL_DONE';
export const SCA_POLL_LOCAL_RESET = 'SCA_POLL_LOCAL_RESET';

export const FETCH_SESSION_STATUS_REQUEST = 'FETCH_SESSION_STATUS_REQUEST';
export const FETCH_SESSION_STATUS_SUCCESS = 'FETCH_SESSION_STATUS_SUCCESS';
export const FETCH_SESSION_STATUS_FAILURE = 'FETCH_SESSION_STATUS_FAILURE';
